import React, { useEffect, useState } from 'react';
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import { MDBDatatable, MDBIcon } from 'mdb-react-ui-kit';
import { useNavigate } from "react-router-dom";
import { getSMSTEMP } from '../services/apiServices';
import MessageFrequency from './frequency';
import SmsGateway from './SmsGateway';
import WhatsappGateway from './WhatsAppGateway';
import {
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
    MDBAlert

} from 'mdb-react-ui-kit';
import { useAccess } from '../context/AccessContext';


function MessageSettings() {
    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const [basicActive, setBasicActive] = useState('tab1');
    const { handlePageAccess } = useAccess();
    const roleAccess = handlePageAccess("templatesandreminders")

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };
    const [fillActive, setFillActive] = useState('tab1');
    const [Error2, setError2] = useState("")

    const handleFillClick = (value) => {
        if (value === fillActive) {
            return;
        }

        setFillActive(value);
    };


    const navigate = useNavigate();


    let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : ""

    const [allTempletes, setAllTempletes] = useState([])


    useEffect(() => {
        async function fetchPData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getSMSTEMP(gymid);
                if (!response) {
                    return;
                }
                if (response == "false") {
                    return;
                }
                const templetes = await response.json();
                setAllTempletes(templetes);
            }
        }
        fetchPData();
    }, [basicActive === 'tab1']);
    console.log(allTempletes);
    const getMemberColumns = () => {
        const baseColumns = [
            { label: 'Template', field: 'Template', sort: false },
            ...((plansInfo !== null && plansInfo.feature.smsintergration)
                ? [{ label: 'SMS', field: 'SMSSettings', sort: false }]
                : []),
            ...((plansInfo !== null && plansInfo.feature.whatsappintegration)
                ? [{ label: 'WhatsApp', field: 'WhatsappSettings', sort: false }]
                : []),
            { label: 'Email', field: 'EmailSettings', sort: false },
        ];

        if (roleAccess?.edittemplate !== 2) {
            baseColumns.push(
                { label: 'Actions', field: 'Actions', sort: false },
            );
        }

        return baseColumns;
    };

    const actionData_1 = {
        columns: getMemberColumns(),
        rows: allTempletes
            .filter(item => item.type === "member")
            .map((templateObj, index) => ({
                Template: templateObj.smscategory,
                ...((plansInfo !== null && plansInfo.feature.smsintergration) ? {
                    SMSSettings: (
                        <div className='cursor-normal'>
                            {templateObj.toggle ? (
                                <MDBIcon fas icon="check" color='success' className='fs-5' />
                            ) : (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            )}
                        </div>
                    ),
                } : {}),

                ...((plansInfo !== null && plansInfo.feature.whatsappintegration) ? {
                    WhatsappSettings: (
                        <div className='cursor-normal'>
                            {templateObj.wtsapptoggle ? (
                                <MDBIcon fas icon="check" color='success' className='fs-5' />
                            ) : (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            )}
                        </div>
                    )
                } : {}),
                EmailSettings: (
                    <div className='cursor-normal'>
                        {templateObj.emailtoggle ? (
                            <MDBIcon fas icon="check" color='success' className='fs-5' />
                        ) : (
                            templateObj.smscategory === "MEMBERSHIP_PAYMENT_ALERT" || templateObj.smscategory === "MEMBER_QR_Code_ALERT" ? (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            ) : (
                                <div className='fw-bold'>NA</div>
                            )
                        )}
                    </div>
                ),
                ...(roleAccess?.edittemplate !== 2 ? {
                    Actions: (
                        <div
                            onClick={() => navigate(`/editmessage`, { state: { row: templateObj, index: index } })}
                            className='text-center'
                        >
                            <MDBIcon fas icon="edit" className="fs-5" />
                        </div>
                    )
                } : {}),
            })),
    };

    const getOwnerColumns = () => {
        const baseColumns = [
            { label: 'Template', field: 'Template', sort: false },
            ...((plansInfo !== null && plansInfo.feature.smsintergration)
                ? [{ label: 'SMS', field: 'SMSSettings', sort: false }]
                : []),
            ...((plansInfo !== null && plansInfo.feature.whatsappintegration)
                ? [{ label: 'WhatsApp', field: 'WhatsappSettings', sort: false }]
                : []),
            { label: 'Email', field: 'EmailSettings', sort: false },

        ];

        if (roleAccess?.edittemplate !== 2) {
            baseColumns.push(
                { label: 'Actions', field: 'Actions', sort: false },
            );
        }

        return baseColumns;
    };

    const actionData_2 = {
        columns: getOwnerColumns(),
        rows: allTempletes.filter(item => item.type !== "member").map((templateObj, index) => {
            return {
                Template: templateObj.smscategory,
                ...((plansInfo !== null && plansInfo.feature.smsintergration) ? {
                    SMSSettings: (
                        <div className='cursor-normal'>
                            {templateObj.toggle ? (
                                <MDBIcon fas icon="check" color='success' className='fs-5' />
                            ) : (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            )}
                        </div>
                    )
                } : {}),
                ...((plansInfo !== null && plansInfo.feature.whatsappintegration) ? {
                    WhatsappSettings: (
                        <div className='cursor-normal'>
                            {templateObj.wtsapptoggle ? (
                                <MDBIcon fas icon="check" color='success' className='fs-5' />
                            ) : (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            )}
                        </div>
                    )
                } : {}),
                EmailSettings: (
                    <div className='cursor-normal'>
                        {templateObj.emailtoggle ? (
                            <MDBIcon fas icon="check" color='success' className='fs-5' />
                        ) : (
                            templateObj.smscategory === "MEMBERSHIP_PAYMENT_ALERT" ? (
                                <MDBIcon fas icon="times" color='danger' className='fs-5' />
                            ) : (
                                <div className='fw-bold'>NA</div>
                            )
                        )}
                    </div>
                ),
                ...(roleAccess?.edittemplate !== 2 ? {
                    Actions: (
                        <div
                            onClick={() => navigate(`/editmessage`, { state: { row: templateObj, index: index } })}
                            className='text-center'
                        >
                            <MDBIcon fas icon="edit" className="fs-5" />
                        </div>
                    )
                } : {}),
            };
        }),
    };
    function onbacktoStaff(flag) {
        setError2(flag);

        setTimeout(() => {
            window.location.reload();
        }, 1000);

    }



    return (
        <React.Fragment>
            <>
                <LeftPane isactive="4" />
                <Header />
                <div className="gym-main gym-main-div rightContent">
                    {/* <MDBIcon fas icon="arrow-left" className="fs-3" onClick={() => showThisInf()} /> */}
                    <div className="gym-container gym-cnr" id="showcase">


                        <MDBTabs className='mb-3'>
                            <MDBTabsItem>
                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                    Templates
                                </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem>
                                <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
                                    Notification Frequency
                                </MDBTabsLink>
                            </MDBTabsItem>
                            {(plansInfo !== null && plansInfo?.feature?.smsintergration) && roleAccess?.edittemplate == 1 &&
                                <MDBTabsItem>
                                    <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                        SMS Settings
                                    </MDBTabsLink>
                                </MDBTabsItem>}
                            {/* {(plansInfo !== null && plansInfo?.feature?.whatsappintegration) && roleAccess?.edittemplate == 1 && */}
                            <MDBTabsItem>
                                <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                    Whatsapp Settings
                                </MDBTabsLink>
                            </MDBTabsItem>
                            {/* } */}


                        </MDBTabs>

                        <MDBTabsContent>
                            <MDBTabsPane open={basicActive === 'tab1'}>
                                <MDBTabs className='mb-3'>
                                    <MDBTabsItem>
                                        <MDBTabsLink onClick={() => handleFillClick('tab1')} active={fillActive === 'tab1'}>
                                            Member
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                    <MDBTabsItem>
                                        <MDBTabsLink onClick={() => handleFillClick('tab2')} active={fillActive === 'tab2'}>
                                            Owner
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                </MDBTabs>

                                <MDBTabsContent>
                                    <MDBTabsPane open={fillActive === 'tab1'}>
                                        <div className="sms-settings-table custon_DT smsTable">
                                            <MDBDatatable className='large-scrool-table' entries={25} pagination={true} hover data={actionData_1} />
                                        </div>
                                    </MDBTabsPane>
                                    <MDBTabsPane open={fillActive === 'tab2'}>
                                        <div className="sms-settings-table custon_DT smsTable">
                                            <MDBDatatable className='large-scrool-table' entries={25} pagination={true} hover data={actionData_2} />
                                        </div>
                                    </MDBTabsPane>
                                </MDBTabsContent>
                            </MDBTabsPane>
                            <MDBTabsPane open={basicActive === 'tab2'}>


                                <MDBTabsContent>

                                    <SmsGateway onbacktoStaff={onbacktoStaff} roleAccess={roleAccess} />

                                </MDBTabsContent>

                            </MDBTabsPane>
                            <MDBTabsPane open={basicActive === 'tab3'}>


                                <MDBTabsContent>


                                    <WhatsappGateway onbacktoStaff={onbacktoStaff} roleAccess={roleAccess} />

                                </MDBTabsContent>


                            </MDBTabsPane>

                            <MDBTabsPane open={basicActive === 'tab5'}>
                                <MessageFrequency allData={allTempletes} roleAccess={roleAccess} />
                            </MDBTabsPane>

                        </MDBTabsContent>
                    </div>
                    <MDBAlert
                        color={Error2.includes("ailed") ? "danger" : "success"}
                        autohide
                        position='top-right'
                        delay={3000}
                        appendToBody
                        open={Error2 !== ""}
                        onClose={() => setError2("")}
                    >
                        {Error2}
                    </MDBAlert>
                </div>
            </>
        </React.Fragment>
    );
}

export default MessageSettings;
